export function useFormatsNumbers() {
    function formatNumber(value: number) {
        // Get the Daalder locale
        let locale = window.wordpress_locale.replace("_", "-");

        const numberParts = new Intl.NumberFormat(locale).formatToParts(value);

        for (const numberPart of numberParts) {
            // Replace the thousands seperator with the Wordpress preference
            if (numberPart.type == "group" && numberPart.value != " ") {
                numberPart.value = window.thousands_seperator;
            }
            // Replace the decimal seperator with the Wordpress preference
            if (numberPart.type == "decimal") {
                numberPart.value = window.decimal_seperator;
            }
        }

        return numberParts
            .map((part) => part.value)
            .join("")
            .trim();
    }

    return {
        formatNumber,
    };
}
